var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-message",class:_vm.type},[_c('sprite-icon',{attrs:{"name":_vm.type}}),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }